import {  useState } from 'react';
import {obtenerActividadesAsistidas} from '../data/Asistencia';
import { useContext } from "react";
import { AuthContext } from "auth";

import moment from 'moment';
import 'moment/locale/es';

export const useAsistencia= () => {
    var {user}= useContext(AuthContext);
    const [columnasActividadesAsistidas,setColumnasActividadesAsistidas]=useState([])
    const [actividadesAsistidas,setActividadesAsistidas]=useState([])
   
    const getActividadesAsistidas= async(Data) => {
        //console.log('getActividadesAsistidas');
        //console.log(Data);
        const respuestaAsistencia=await obtenerActividadesAsistidas(Data,user.Token);
        //console.log(JSON.stringify(respuestaAsistencia));
        setActividadesAsistidas(respuestaAsistencia.ActividadesAsistidas);
        setColumnasActividadesAsistidas(respuestaAsistencia.Columnas);
    }
    
    return {
        getActividadesAsistidas,
        columnasActividadesAsistidas,
        actividadesAsistidas

       
       
               
       
    }
}
